// extracted by mini-css-extract-plugin
export default {"tile-badge":"recommendationspwuuvU","tile-badge__label":"recommendationsFp5YWw","tile-badge__label--super-offer":"recommendations0QRCTk"};